export { default } from './FilterText'
